import React from 'react';

import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const FormatSettingsSkeleton = () => (
    <FormSectionSkeleton labelWidth={155}>
        <Group alignItems="start" direction="v">
            <Group>
                <SkeletonItem width={14} height={14}/>
                <SkeletonItem width={120} height={18}/>
            </Group>
            <Group gap="xl">
                <FormItemSkeleton labelWidth={54}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={100}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={135}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
            </Group>
            <Group gap="xl">
                <FormItemSkeleton labelWidth={100}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={100}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
            </Group>
            <Group gap="xl">
                <FormItemSkeleton labelWidth={90}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={90}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
            </Group>
        </Group>
    </FormSectionSkeleton>
);
